<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page tags-page mt-4" v-else-if="loaded" >
        
        <b-input-group class="mb-4" >
            <b-form-input v-model="filter" placeholder="Type to search..." class="search-input atlass-input-borderless" />
            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
        </b-input-group>
        <!--
        <div class="col-12 tag font-size-14 d-none" v-if="matches" v-for="(tag, index) in matches"  >
            <div class="row pt-2 pb-2 tag-row" >
                <span class="span-width" > {{ formatDate(tag) }} </span>
                <span class="tag-span" >
                    
                </span>
            </div>
        </div>
        -->
        
        <div class="w-100 text-center mt-5 font-size-16 font-500" v-if="matches.length == 0" >
            No tags yet
        </div>
        
        <div class="w-100 tags-container overflow-auto" v-else-if="matches.length > 0" >
            
            <div class="col-12 tag font-size-14" :class="'tag-type-'+tag.type" v-for="(tag, index) in matches"  >
                <div class="row border-left-gray pt-3 pb-3 ml-1 ml-md-5" >
                    
                    <div class="col-12 d-block pl-4"  >

                        <span v-if="tag.origin_type == 'page' && tag.type != 2" > Landed on </span>
                        <span v-else-if="tag.origin_type == 'milestone' && tag.type == 1" > Came from </span>
                        <span v-else-if="tag.origin_type == 'BOT' && tag.type == 0" >  </span>


                        <span v-else-if="tag.type == 0 && ( tag.origin == 'ATLASS' || tag.origin == 'TRACKER' )" > Hit a milestone </span> 
                        <span v-else-if="tag.type == 2" > Made a conversion </span>
                        <span v-else-if="tag.type == 1" > Clicked on </span>

                        <span class="font-weight-bold" > {{tag.name}} <span v-if="tag.tag != ''" class="d-none d-md-inline-block" > ( {{tag.tag}} )  </span> </span>
                        
                        <!-- AVG CONVERSION DURATION -->
                        <span v-if="tag.type == 1 && tag.duration" :id="`tooltip--tag--${tag.name}--${tag.id}`" class="atlass-tag-box font-500 font-size-12" >  
                            <font-awesome-icon icon="stopwatch" ></font-awesome-icon> 
                            {{ AVGConversionDuration( tag ) }} 
                        </span> 
                        <b-tooltip :target="`tooltip--tag--${tag.name}--${tag.id}`" placement="bottom" triggers="hover" custom-class="tooltip-auto"  > Time to conversion </b-tooltip>
                        <!-- AVG CONVERSION DURATION -->
                        
                        <span v-if="tag.origin_type == 'page' && tag.type != 2" > page </span>
                        <span v-if="tag.type == 2 && tag.price > 0" > priced at  </span>
                        <span v-if="tag.type == 2 && tag.price > 0" class="font-weight-bold" > ${{tag.price}}  </span>

                        <a @click="preventDeleteTag( tag )" v-if="pageType == 'edit' && tag.type != 2" > <font-awesome-icon icon="trash-alt" /> </a>
                    </div>
                    
                    <div class="col-12 d-block tag-datetime position-relative pl-4 pr-4 " > 
                        <span class="timeline-bullet" >
                            <span v-if="tag.origin == 'MAILCHIMP'" class="timeline-icon" > <font-awesome-icon :icon="['fab', 'mailchimp']" /> </span>
                            <span v-if="tag.origin == 'ACTIVECAMPAIGN'" class="timeline-icon rounded" > <img src="@/assets/icons/activecampaign.png" /> </span>
                            <span v-if="tag.origin == 'WOOCOMMERCE'" class="timeline-icon rounded" > <img src="@/assets/icons/woocommerce.png" /> </span>
                            <span v-if="tag.origin == 'SHOPIFY'" class="timeline-icon" > <img src="@/assets/icons/shopify.png" /> </span>
                            <span v-if="tag.origin == 'CLICKFUNNELS'" class="timeline-icon" > <img src="@/assets/icons/clickfunnels.png" /> </span>
                            <span v-if="tag.origin == 'ZAPIER'" class="timeline-icon" > <img src="@/assets/icons/zapier.png" /> </span>
                            <span v-if="tag.origin == 'STRIPE'" class="timeline-icon" > <img src="@/assets/icons/stripe_icon.png" /> </span>
                            <span v-if="tag.origin == 'OPENCART'" class="timeline-icon rounded" > <img src="@/assets/icons/opencart.png" /> </span>
                            <span v-if="tag.origin == 'GOOGLE'" class="timeline-icon " > <img src="@/assets/icons/googleadwords.png" />  </span>
                            <span v-if="tag.origin == 'FACEBOOK'" class="timeline-icon rounded" > <img src="@/assets/icons/facebook.png" />  </span>
                            <span v-if="tag.origin == 'TIKTOK'" class="timeline-icon rounded" > <img src="@/assets/icons/tiktok.png" />  </span>

                            <span v-if="tag.origin == 'ATLASS' || tag.origin == 'TRACKER' || tag.origin == 'API' " class="timeline-icon" > <img src="@/assets/icons/atlass.svg" /> </span>
                        </span> 
                        {{ formatDate(tag) }} 
                    </div>
                </div>
            </div>

            <div class="col-12 tag font-size-14" >
                <div class="row border-left-gray pt-3 pb-3 ml-1 ml-md-5" >
                    <div class="d-inline-block tag-datetime position-relative pl-4 pr-4 " > 
                        <span class="timeline-bullet" style="margin-left: -10px;" > <span class="timeline-icon" > </span> </span> 

                    </div>
                    <div class="d-inline-block pl-4"  > <span class="" >  </span> </div>
                </div>
            </div>

            <!--
            <div class="col-12 tag font-size-14" v-if="created" >
                <div class="row" >
                    <div class="d-inline-block tag-datetime position-relative pt-3 pl-4 pr-4 border-right-gray" > 
                        <span class="timeline-bullet" > <span class="timeline-icon" > <img src="@/assets/icons/atlass.svg" /> </span> </span> 
                        {{ formatDate(created) }} 
                    </div>
                    <div class="d-inline-block pt-3 pl-4"  > <span class="" > Visitor was first seen  </span> </div>
                </div>
            </div>
            -->
        
        </div>
    
    </div>

</template>

<script>
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
import axios from 'axios'

export default {
    name: 'tagsComponent',
    props: {
        data: { 
            type: [Array],
        },
        pageType:{
            type: [String],
            default: 'edit'
        },
        leadID: {
            type: [String],
        }
    },
    data: function(){
        return {
            filter: '',
            loaded: false,
            timeout: 100,
            create: false
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //console.log(this.data)
        this.get_LeadData()
        if( this.data.length > 0 ){
            


            //console.log("Tags component")
            //console.log(this.data)
            //this.data.sort((a, b) => b.datetime - a.datetime);
            //let tags = this.data
            //let last = tags[tags.length - 1]
            //this.created = last.datetime - 1

        }

        this.loaded = true;
        
    },
    beforeDestroy() {
    },
    methods: {
        
        setCreatedTag( lead ){
            
            let optinTag = {                        
                datetime: lead.datetime_created,
                leadID: lead.id,
                name: "Lead was created",
                origin: "ATLASS",
                origin_type: "BOT",
                tag: " opted in ",
                type: 0
            }
            
            let visitorTag = {                        
                datetime: lead.datetime,
                leadID: lead.id,
                name: "Visitor was first seen",
                origin: "ATLASS",
                origin_type: "BOT",
                tag: "",
                type: 0
            }

            if( lead.datetime == lead.datetime_created ){
                this.data.push( optinTag )
            }else if( !lead.datetime_created ){
                this.data.push( visitorTag )
            }else{
                this.data.push( optinTag )
                this.data.push( visitorTag )
            }

            this.data.sort((a, b) => b.datetime - a.datetime);
            //console.log( this.rows )
            
        },
        
        get_LeadData(){
            
            let passedOrganization = null
            if( this.$route.params.passed_organizationID ){
                passedOrganization = this.$route.params.passed_organizationID
            }
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, passedOrganization )
            
            const db = this.$firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/leads/').doc( this.leadID );

            let results = []
            ref.get()
            .then((snapshot) => {
                //console.log(snapshot.data())
                let lead = snapshot.data()
                lead.id = snapshot.id
                this.setCreatedTag( lead )
                //results.push(lead)
            })
            .then((r)=>{
                
                let sourceTags = []
                let SUM_DURATION = 0
                //this.data.forEach((tag)=>{ tags.push(tag) })
                this.data.sort((a, b) => a.datetime - b.datetime);
                this.data.forEach((item)=>{
                    //console.log(item)
                    if( item.type == 1 ){
                        //FOUNT FIRST SOURCE TAG
                        //console.log( "Found source tag: " + JSON.stringify( item ) )
                        let FOUND = null
                        this.data.forEach((conversion)=>{
                            if( conversion.type == 2 && conversion.datetime > item.datetime && FOUND == null ){
                                //console.log( "Found closest conversion: " + JSON.stringify( conversion ) )
                                
                                FOUND = conversion
                                //console.log(item)
                            }
                        })
                        
                        if( FOUND != null ){
                            item.duration = FOUND.datetime - item.datetime

                            sourceTags.push( item )
                            SUM_DURATION = SUM_DURATION + parseInt( item.duration )
                        }
                        
                    }

                })
                
                this.data.sort((a, b) => b.datetime - a.datetime);
                
                let AVG = parseInt( ( SUM_DURATION / sourceTags.length ).toFixed(0) )
                //console.log( "AVG duration: " +  helper.secondsToDhms( AVG ) )
                
                //console.log(this.$parent.$parent.$parent.data)
                this.$parent.$parent.$parent.data.AVG_CONVERT = AVG
                
            })
                        
        },
        
        formatDate(a, format = 'HH:mm:ss MMM D, YYYY'){
            if( typeof a == 'number' ){
                //return this.$moment.unix(a).format( format )
                return helper.formatDate( a, format )
            }else{
                //return this.$moment.unix(a.datetime).format( format )
                return helper.formatDate( a.datetime, format )
            }
            
        },
        preventDeleteTag( tag ){
            
            console.log(tag)
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone and the conversion will be deleted as well',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    if( tag.type == 2 ){
                        
                        //OPTION FOR DELETING ORDER TAG WAS MOVED TO ORDERS -> Actions -> Delete
                        
                    }else{
                        
                        this.deleteTag(tag);
                        
                    }
                    
                    
                }
            })
            
        },        
        deleteTag: function(tag){
            
            this.loaded = false
            
            let passedOrganization = null
            if( this.$route.params.passed_organizationID ){
                passedOrganization = this.$route.params.passed_organizationID
            }
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, passedOrganization )
            
            let leadID = tag.leadID
            
            const db = this.$firebase.firestore();
            let firestore = this.$firebase.firestore
            
            let refTag = db.collection('organizations/'+orgID+'/leads').doc( leadID ).collection('tags').doc( tag.id ).delete()
            .then((r)=>{
                
                db.collection('organizations/'+orgID+'/leads').doc( leadID ).update({
                   tags: firestore.FieldValue.arrayRemove( tag.tag )
                });
                
            })
            .then((final)=>{
                console.log("Success")
                this.$toast.success({
                    title: 'Success',
                    message: 'Tag deleted'
                })
            })
            
            setTimeout(function(){ 
                //console.log(this.$parent)
                this.loaded = true
                //this.$parent.$parent.$parent.get_data( 'tags' );
                //remove from current array
                
                if ('panel' in this.$parent.$refs) {
                    console.log('tabs modal')
                    //RELOAD TAG LIST
                    this.$parent.$parent.$parent.get_data( 'tags' );
                    //CHECK IF TAG IS TYPE 2
                    //UPDATE LEAD REVENUE
                    if( tag.type == 2 ){
                        //console.log( this.$parent.$parent.$parent )
                        //this.$parent.$parent.$parent.$parent.get_data();
                        this.$parent.$parent.$parent.ID.revenue -= tag.price;
                    }
                }else{
                    console.log('page')
                    //RELOAD TAG LIST
                    this.$parent.get_data();
                    //CHECK IF TAG IS TYPE 2
                    //UPDATE LEAD REVENUE
                    if( tag.type == 2 ){
                        this.$parent.$parent.data.revenue -= tag.price;
                    }
                    
                }
                
            }.bind(this), this.timeout );
                
        },
        
        delete_SQL_order(tagID){
              
            console.log("delete SQL order")
            return false
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "xauth": Cookies.get('user-token') }
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/sql/orders/delete', 
                headers: headers, 
                data: { 
                    "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    //"APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    "tagID": tagID
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.data.status == 103 ){
                    
                    this.$swal({
                        title: 'Refresh required',
                        text: 'Please reload the page in order to refresh the session token ',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, refresh'
                    }).then((result) => {
                        if (result.value) { 
                            window.location.reload()
                        }
                    })
                    
                }else{
                    
                    this.$toast.success({
                        title: 'Success',
                        message: 'Product deleted'
                    })

                    setTimeout(function(){ 
                        this.loaded = true

                        if ('panel' in this.$parent.$refs) {
                            //RELOAD TAG LIST
                            this.$parent.$parent.$parent.get_data( 'tags' );
                            this.$parent.$parent.$parent.ID.revenue -= tag.price;
                            
                        }else{
                            //RELOAD TAG LIST
                            this.$parent.get_data();
                            this.$parent.$parent.data.revenue -= tag.price;

                        }

                    }.bind(this), this.timeout );
                    
                }
            })
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error calculating LTV. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
        
        AVGConversionDuration( tag ){
            
            //console.log(tag)
            
            let avgDuration = ""
            /*
            if( tag.duration ){
                avgDuration = this.$moment.utc( this.$moment.duration(tag.duration, "seconds").asMilliseconds() ).format( "HH:mm" ) 
                if( tag.duration > 60*60*24 ){
                    avgDuration = this.$moment.utc( this.$moment.duration(tag.duration, "seconds").asMilliseconds() ).format( "d" ) + " days " +  
                                    this.$moment.utc( this.$moment.duration(tag.duration, "seconds").asMilliseconds() ).format( "HH:mm" ) 
                }
            }*/
            avgDuration = helper.secondsToDhms( tag.duration )
            return avgDuration
        }
        
    },
    computed: {
        matches() {
            return this.filter
                ? this.data.filter(row => {
                  let match = false
                  for (let key in row) {
                    //console.log(campaign['name']);
                    if ( row['name'].toLowerCase().includes(this.filter.toLowerCase()) || row['tag'].toLowerCase().includes(this.filter.toLowerCase()) ) {
                      return true
                    }
                  }
                })
                : this.data
        }
    },
    watch: {
        ID: function(){
            if( typeof this.ID == 'string' ){
                this.docID = this.ID
            }else{
                this.data = this.ID
            }
    
            //this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >

    @import '@/assets/css/variables.scss';

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 150px;
        display: inline-block;
        margin-right: 10px;
    }
    .tag-span{
        display: inline-block;
    }
    .tag-span a{
        display: none;
        transition: all .3s;
        transition-timing-function: ease-out;
    }
    
    .tag-row:hover a{
        display: inline-block;
        transition: all .3s;
        transition-timing-function: ease-out;
    }
    
    /*
    .tag-datetime{
        min-width: 200px;
        text-align: right;
    }
    */
    .tag-type-1 span.font-weight-bold{
        color: $bluec;
    }
    .tag-type-2 span.font-weight-bold{
        color: $greenc;
    }
    
    .tags-container{
        max-height: 54vh;
        max-height: calc( 100vh - 450px );
    }
    
    .atlass-tag-box{
        border: 1px solid rgb(61 106 210);
        padding: 2px 9px;
        border-radius: 2rem;
        background: rgb(62 105 208);
        color: #fff;
    }
    
    .atlass-tag-box .svg-inline--fa{
        vertical-align: initial!important;
    }
    
    @media screen and (max-width: 767px){
        .tags-container{
            max-height: calc( 100vh - 270px );
            max-height: 100%;
            height: 100%;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/tags.vue